import React from "react";
import styled from "styled-components";

const Footer = () => {
  const date = new Date().getFullYear();
  return (
    <FooterWrapper>
      <FooterSurface>
        <FooterInner>
          <SocialList>
            <SocialItem>
              <SocialLink
                href="https://www.facebook.com/junaid4u.ahmad"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <i className="fab fa-facebook"></i>
              </SocialLink>
            </SocialItem>
            <SocialItem>
              <SocialLink
                href="https://www.linkedin.com/in/juac08"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <i className="fab fa-linkedin"></i>
              </SocialLink>
            </SocialItem>
            <SocialItem>
              <SocialLink
                href="https://github.com/juac08"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="GitHub"
              >
                <i className="fab fa-github"></i>
              </SocialLink>
            </SocialItem>
            <SocialItem>
              <SocialLink
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <i className="fab fa-instagram"></i>
              </SocialLink>
            </SocialItem>
          </SocialList>
          <Copyright>© {date} Junaid Ahmad.</Copyright>
        </FooterInner>
      </FooterSurface>
    </FooterWrapper>
  );
};

export default Footer;

const FooterWrapper = styled.footer`
  background: var(--bg-app);
  padding: 0 1rem 1rem 1rem;
  text-align: center;
  width: 100%;
  min-width: 0;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 90;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
`;

const FooterInner = styled.div`
  width: 100%;
  max-width: 820px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
`;

const SocialList = styled.ul`
  display: flex;
  justify-content: center;
  gap: 2rem;
  list-style: none;
  margin: 0 0 1rem 0;
  padding: 0;
`;

const SocialItem = styled.li``;

const SocialLink = styled.a`
  color: #f7f9fc;
  font-size: 1.6rem;
  transition: transform 0.2s, color 0.2s;
  &:hover {
    color: #cfe3ff;
    transform: translateY(-2px);
  }
`;

const Copyright = styled.p`
  color: #e0e0eb;
  font-size: 1rem;
  margin: 0;
  font-family: "Montserrat", sans-serif;
`;

const FooterSurface = styled.div`
  width: 100%;
  max-width: 820px;
  background: linear-gradient(
    135deg,
    rgba(30, 60, 114, 0.92),
    rgba(42, 82, 152, 0.94)
  );
  border-radius: 18px;
  padding: 1.25rem 1.25rem 1rem 1.25rem;
  box-shadow: 0 -14px 32px rgba(12, 24, 60, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.14);
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
`;
